import React from "react";
import styles from "./PriceBreakoutSection.module.scss";
import Text from "@components/atoms/Text";
import { formatCurrencyINR } from "@utils/numberFormatter";
import type { PriceBreakupRow } from "@helpers/customCardHelper";

interface PriceBreakoutSectionProps {
  charges: PriceBreakupRow[];
  discounts: PriceBreakupRow[];
  savingsRows?: PriceBreakupRow[];
  summaryRows?: PriceBreakupRow[];
  finalPrice: string;
  isSellable: boolean;
  consumerSavings?: string;
  savingBalance?: any;
}

export default function PriceBreakoutSection({
  charges,
  discounts,
  savingsRows,
  summaryRows,
  finalPrice,
  isSellable,
  consumerSavings,
  savingBalance
}: PriceBreakoutSectionProps) {
  const effectiveSavingsRows =
    savingsRows && savingsRows.length > 0
      ? savingsRows
      : consumerSavings
        ? [{ label: "Consumer Savings", value: consumerSavings }]
        : [];
  const effectiveSummaryRows =
    summaryRows && summaryRows.length > 0 ? summaryRows : discounts;
  const primaryChargeRows = charges.filter(
    (row) => !row.section || row.section === "primary"
  );
  const insuranceChargeRows = charges.filter(
    (row) => row.section === "insurance"
  );
  const miscChargeRows = charges.filter((row) => row.section === "misc");
  const savingsOnlyRows = effectiveSavingsRows.filter(
    (row) => row.section !== "summary"
  );
  const summaryOnlyRows = [
    ...effectiveSummaryRows,
    ...effectiveSavingsRows.filter((row) => row.section === "summary"),
  ];

  const renderRows = (rows: PriceBreakupRow[]) =>
    rows.map(
      ({ label, value }) =>
        value && (
          <div key={label} className={styles.row}>
            <p className={styles.label}>{label}</p>
            <p
              className={
                label === "ACKO Drive discount"
                  ? styles.discount
                  : styles.value
              }
            >
              {value}
            </p>
          </div>
        )
    );

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        {renderRows(primaryChargeRows)}
        {insuranceChargeRows.length > 0 && <div className={styles.divider}></div>}
        {renderRows(insuranceChargeRows)}
        {miscChargeRows.length > 0 && <div className={styles.divider}></div>}
        {renderRows(miscChargeRows)}
        {savingsOnlyRows.length > 0 && <div className={styles.divider}></div>}
        {renderRows(savingsOnlyRows)}
        {savingBalance > 0 && (
          <Text className={styles.savingBalanceText}>
            (<span className={styles.savingBalanceValue}>{formatCurrencyINR(savingBalance)}</span> New car savings balance applied)
          </Text>
        )}
        {summaryOnlyRows.length > 0 && <div className={styles.divider}></div>}
        {renderRows(summaryOnlyRows)}
      </div>
      {isSellable && (
        <div className={styles.finalPriceBox}>
          <div className={styles.row}>
            <p className={styles.finalLabel}>ACKO Drive price</p>
            <p className={styles.finalValue}>{finalPrice}</p>
          </div>
        </div>
      )}
    </div>
  );
}
